import { mapActions, mapGetters } from "vuex";
export const portalPermission = {
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters("common", ["plans", "plan"]),
    ...mapGetters("plansMembers", ["options", "planOptions", "planIdentity"]),
  },
  methods: {
    checkPermissions() {
      if (
        !this.planIdentity.HasDrupalPortal ||
        !this.planIdentity.MembersPortal ||
        !this.planIdentity.MembersPortal.IsActive
      ) {
        this.$router.push({
          name: "homeWithPlan",
          params: { planId: this.plan.Id },
        });
      }
    },
  },
  mounted() {
    if (this.plan !== null && this.plan !== undefined) {
      this.checkPermissions();
    }
  }
};
